import type { StatusVariantMap } from '@zafroi/ui-kit';

export const contractStatusVariants: StatusVariantMap = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  PENDING_APPROVAL: { label: 'Pending approval', tone: 'warning' },
  ACTIVE: { label: 'Active', tone: 'success' },
  COMPLETED: { label: 'Completed', tone: 'info' },
  TERMINATED: { label: 'Terminated', tone: 'destructive' },
  EXPIRED: { label: 'Expired', tone: 'neutral' },
  CLOSED: { label: 'Closed', tone: 'neutral' },
};

export const milestoneStatusVariants: StatusVariantMap = {
  PLANNED: { label: 'Planned', tone: 'neutral' },
  ACCEPTED: { label: 'Accepted', tone: 'info' },
  BILLED: { label: 'Billed', tone: 'warning' },
  PAID: { label: 'Paid', tone: 'success' },
};
